export default __webpack_public_path__ + "static/media/Onibus.93e9cef1.svg";